module.exports = __webpack_public_path__ + "img/about-us.706f4a62.png";